import React, { useContext, useEffect, useState } from 'react'
import PageTitle from '../../../jsx/layouts/PageTitle';
import ReactPaginate from 'react-paginate';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { formatDateTime } from '../../../utils/dateTimeFormate';
import { getAlldataverifiedDwnload, getVerifieddataList } from '../../../services/adminApiService/verifiedlistApiService/VerifiedLIstApiService';
import FilterNumber from '../../../jsx/components/FilterNumberDropDown/FilterNumber';
import SearchFilter from '../../../jsx/components/SearchFilter/SearchFilter';
import useSearchValue from '../../../hooks/useSearchValue';
import CategorySubCategoryFilter from '../categorySubCateogoryFilter/CategorySubCategoryFilter';
import DistrictFilter from '../districtFilter/DistrictFilter';
import { LocationContext } from '../../../context/LocationContext';
import { useCategoryFilter } from '../../../context/CategoryFilterContext';
import { useFilterReset } from '../../../hooks/useFilterReset';
import RefreshButton from '../../../jsx/components/RefreshButton/RefreshButton';
import { useSport } from '../../../context/SportContext';
import SportFilter from '../sportFilter/SportFilter';
import DownloadExcelButton from '../../../jsx/components/DownloadExcelButton.jsx/DownloadExcelButton';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { VerifiedIndividualExcelHeaders } from './VerifiedIndividualExcelData';
import { FaChevronDown } from "react-icons/fa";
import "./style.css"
import { getOrganisationList, getOrganisationListForExcel } from '../../../services/adminApiService/organisationApi/OrganisationApiService';
import { exportToExcel , exportVerifiedToExcel } from '../../../utils/exportToExcel';
import TextMasked from '../../../utils/TextMasked';

const VerifiedUserList = ({ roletype, roleCategory }) => {
    const [verifiedUserdataList, setVerifiedUserdataList] = useState([]);
    const { selectedDistrictId, setSelectedDistrictId } = useContext(LocationContext);
    const { selectedSubCategoryId, setSelectedSubCategoryId } = useCategoryFilter();
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { searchValue, setSearchValue, debouncedSearchValue, setDebouncedSearchValue } = useSearchValue();
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedSubCategory, setSelectedSubCategory] = useState('');
    const { selectedSportId, setSelectedSportId } = useSport();
    const [selectedYear, setSelectedYear] = useState(null);
    const yearValue = selectedYear ? selectedYear.getFullYear() : '';



    const handleVerificationClick = (id) => {
        navigate(`/verification-view-form/${id}`); // Absolute path
    };

    const getverifiedListApi = async (roletype, perPage, currentPage, searchValue, selectedDistrictId,selectedCategory, selectedSubCategoryId, selectedSportId, yearValue) => {
        setLoading(true);
        try {
            const response = await getVerifieddataList(roletype, perPage, currentPage, searchValue, selectedDistrictId,selectedCategory, selectedSubCategoryId, selectedSportId, yearValue);

            setVerifiedUserdataList(response?.data?.data);
        } catch (error) {
            console.error('Login error:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getverifiedListApi(roletype, perPage, currentPage, debouncedSearchValue, selectedDistrictId,selectedCategory, selectedSubCategoryId, selectedSportId, yearValue);
    }, [currentPage, perPage, debouncedSearchValue, selectedDistrictId, selectedCategory,selectedSubCategoryId, selectedSportId, yearValue]);

    const handlePageChange = (event) => {
        const selectedPage = event.selected + 1;
        setCurrentPage(selectedPage);
    };
    const handleRefresh = useFilterReset({
        setSearchValue,
        setDebouncedSearchValue,
        setSelectedDistrictId,
        setSelectedSubCategoryId,
        setSelectedCategory,
        setSelectedSubCategory,
        setPerPage,
        setCurrentPage,
        setSelectedYear,
        setSelectedSportId,
        fetchFunction: getverifiedListApi,
        fetchArgs: [roletype, 10, 1, "", "", "", "",""]


    });
    useEffect(() => {
        setCurrentPage(1);
        setPerPage(10);
        // setSelectedStatus(0);
        setDebouncedSearchValue("");
        setSelectedDistrictId("");
        setSelectedSubCategoryId("");
        setSelectedSportId("");
    }, []);

    const handleDataToExcel = async ({userId}) => {
          try {
              const response = await getOrganisationListForExcel(userId, searchValue,selectedDistrictId,selectedSubCategoryId,selectedSportId);
              const data = response.data;
              exportVerifiedToExcel(data,"InsitutionListVerified.csv");
          } catch (error) {
              console.error('Login error:', error);
          } 
      };


    return (
        <>
            <PageTitle activeMenu="Individual Verification List"
                motherMenu="Manage Verification" />
            <div className="col-12">
                <div className="card filter-card-wrapper">
                    <div className="px-3 d-flex justify-content-between">
                        <div className="d-flex mt-3 mx-2">
                            <div>
                                <FilterNumber value={perPage} onChange={(val) => {
                                    setPerPage(val);
                                    setCurrentPage(1) // ✅ sync with download
                                }} />
                            </div>
                            <div>
                                <SearchFilter searchValue={searchValue} setSearchValue={setSearchValue} setCurrentPage={setCurrentPage} />
                            </div>

                        </div>
                        <div className="d-flex mt-3">
                            <div className="me-2">
                                 <DownloadExcelButton userId={1} searchValue={searchValue} selectedDistrictId={selectedDistrictId} 
                                selectedSubCategoryId={selectedSubCategoryId} selectedSportId={selectedSportId} />
                            </div>
                            {/* <div className="">
                                <DownloadExcelButton data={verifiedUserdataList}
                                     headers={[
                                        { label: "S.No", key: "serial" }, // Add Serial Number column
                                        ...VerifiedIndividualExcelHeaders
                                    ]}
                                    btnName="Download All Data"
                                    fileName="AllIndividualListVerified.xlsx"
                                       onClick={async () => {
                                        const response = await getAlldataverifiedDwnload(1);
                                        const allData = response?.data?.data || [];
                                        const withSerial = allData.map((item, index) => ({
                                            serial: index + 1,  // matches header key
                                            ...item
                                        }));

                                        return withSerial;
                                    }}
                                />
                            </div> */}
                            <div>
                                <RefreshButton refreshCallback={handleRefresh} />
                            </div>


                        </div>

                    </div>
                    <div className="mx-4 d-flex mt-2 ">
                        <div>
                            <SportFilter setCurrentPage={setCurrentPage}/>
                        </div>
                        <div className="ms-2">
                            <DistrictFilter setCurrentPage={setCurrentPage}/>

                        </div>



                        <div className="date-picker-wrapper mx-2">
                            <DatePicker
                                selected={selectedYear}
                                onChange={(date) => setSelectedYear(date)}
                                showYearPicker
                                dateFormat="yyyy"
                                placeholderText="Select Dob Year"
                                className="form-control custom-datepicker"
                            />
                            <FaChevronDown className="datepicker-icon" />
                        </div>

                        <div className="mx-2">
                            <CategorySubCategoryFilter typeId="1"
                                selectedCategory={selectedCategory}
                                setSelectedCategory={setSelectedCategory}
                                selectedSubCategory={selectedSubCategory}
                                setSelectedSubCategory={setSelectedSubCategory}
                                placeholderText="Individual"
                                setCurrentPage={setCurrentPage}
                            />
                        </div>

                    </div>



                    <div className="card-body">
                        {loading ? (
                            <div className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <div className="w-100 table-responsive">
                                <div id="example_wrapper" className="dataTables_wrapper">
                                    <table id="example" className="display w-100 dataTable">
                                        <thead>
                                            <tr>
                                                <th>SN</th>
                                                {/* <th>Prov.Reg.Id</th> */}
                                                <th>Unique Id</th>
                                                <th>Applicant Full Name</th>
                                                <th>Sport Name</th>
                                                <th>Contact Number</th>
                                                <th>Registration Date</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {verifiedUserdataList?.data?.length > 0 ? (
                                                verifiedUserdataList.data.map((data, index) => {
                                                    const serialNumber = (currentPage - 1) * perPage + (index + 1);
                                                    return (
                                                        <tr key={index}>
                                                            <td>{serialNumber}</td>
                                                            {/* <td>{data?.registration_id}</td> */}
                                                            <td>{data?.atom_id}</td>
                                                            <td>{data?.name}</td>
                                                            <td>{data?.indivisual?.refsport?.sport_name}</td>
                                                            {/* <td>{data?.indivisual?.mobile}</td> */}
                                                            <td><TextMasked value={data?.mobile} type="phone" /></td>
                                                            <td>{formatDateTime(data?.created_at)}</td>

                                                            <td>
                                                                <span className="text-success">Verified</span>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex">
                                                                    <Button style={{ whiteSpace: 'nowrap' }} onClick={() => handleVerificationClick(data?.id)}> View More </Button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="9" className="text-center">Data is not available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
                <ReactPaginate
                    nextLabel="next >"
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={8}
                    marginPagesDisplayed={7}
                    pageCount={Math.ceil(verifiedUserdataList?.total / perPage)}
                    previousLabel="< previous"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination d-flex flex-wrap"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                />
            </div>
        </>
    )
}

export default VerifiedUserList